/* eslint-disable no-extra-boolean-cast */
import React from "react";
import { ConfigurationOption } from "../ProductDetailPageResult";
import { VirtualGroupingOptionsToMap } from "./VirtualGroupingModel";
import { User } from "~/common/Store/models/User";
import getVirtualGroupingDropdownItemPricing from "./getVirtualGroupingDropdownItemPricing";
import { getSelectedOptionAndSendGtmEvent } from "../../userAnalytics";
import { getSortedOptions } from "~/ProductDetails/VirtualGrouping/VirtualGroupingHelper";
import { useProductDetailsContext } from "../ProductDetailsStore";
interface Props {
  selectedOptions: readonly ConfigurationOption[];
  handleClickVirtualGroupingVariation: (name: string, value: string, validOption: boolean) => void;
  dropdown: VirtualGroupingOptionsToMap;
  showError: boolean;
  user: User;
  hasMoreThanOneDropdown: boolean;
  showPricingInDropdown?: boolean;
}
const sendGtmEventOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
  getSelectedOptionAndSendGtmEvent(event.target.value, "PDP Options Click", event.target);
};
const GroupConfigurationSelect = ({
  dropdown,
  handleClickVirtualGroupingVariation,
  selectedOptions,
  showError,
  user,
  hasMoreThanOneDropdown,
  showPricingInDropdown = true
}: Props) => {
  const store = useProductDetailsContext();
  const {
    isGoogleView
  } = store.getState();
  const sortedDropdownOptions = getSortedOptions(dropdown?.variations);
  return <div className="form__group" data-sentry-component="GroupConfigurationSelect" data-sentry-source-file="GroupConfigurationSelect.tsx">
      <div className={`form__control-container ${showError ? " error" : ""}`}>
        <select className="accessory-filter form__control grouping-select [&:not(:placeholder-shown)]:pb-0.5" id={dropdown.name} value={selectedOptions.find(option => option.name === dropdown.name)?.value || "default"} data-testid="virtual-grouping-select" onChange={e => {
        sendGtmEventOnChange(e);
        handleClickVirtualGroupingVariation(dropdown.name, e.target.value, dropdown.validOptions.includes(e.target.value));
      }}>
          <option disabled key="default" value="default">{`Select ${dropdown.name}`}</option>
          {sortedDropdownOptions && sortedDropdownOptions?.length > 0 && sortedDropdownOptions.map(option => <option disabled={!dropdown.validOptions.includes(option.value)} value={option.value} key={option.value}>
                {option.value}
                {!hasMoreThanOneDropdown && showPricingInDropdown ? getVirtualGroupingDropdownItemPricing(option, user, isGoogleView) : null}
              </option>)}
        </select>
        <label className="form__label ">
          <span className="form__label-text">{dropdown.name}</span>
          <span className="required">Required</span>
        </label>
        <i className="icon-down-micro form__control-icon form__control-icon--lg" />
      </div>
    </div>;
};
export default GroupConfigurationSelect;